export default __webpack_public_path__ + "static/media/services_bg.cd245520.jpg";